import MyLocationRoundedIcon from "@mui/icons-material/MyLocationRounded";

export const location = (props) => {
  return <MyLocationRoundedIcon {...props} />;
};
